<app-breadcrumb [title]="'Investigación de siniestros'" [items]="['Pesv']"
  [active_item]="'Investigación interna de siniestros viales'"></app-breadcrumb>

<div class="container-fluid">
  <div class="card shadow-sm border-0">
    <div class="card-header bg-primary text-white d-flex align-items-center">
      <i class="icofont icofont-search-alt-2 me-2"></i>
      <h5 class="mb-0"><strong>INVESTIGACIÓN INTERNA DE SINIESTROS VIALES</strong></h5>
    </div>

    <div class="card-body">
      <ul ngbNav #investigacionTab="ngbNav" [(activeId)]="activeTab" class="nav-tabs">

        <!-- TAB 1: FORMULARIO -->
        <li [ngbNavItem]="1">
          <a ngbNavLink><strong><i class="icofont icofont-plus me-1"></i> FORMULARIO INVESTIGACIÓN</strong></a>
          <ng-template ngbNavContent>
            <form [formGroup]="investigacionForm" (ngSubmit)="guardar()" class="pt-3" novalidate>
              <div class="card border-0 shadow-sm mb-3">
                <div class="card-body row g-3">

                  <div class="col-md-3">
                    <label class="form-label text-dark">Siniestro: <span class="text-danger">*</span></label>
                    <ng-select [items]="siniestrosActivos" bindLabel="consecutivo" bindValue="id"
                      [loading]="cargandoSiniestros" formControlName="id_siniestro"
                      placeholder="Seleccione el siniestro a investigar..." [disabled]="modoEdicion">
                      <ng-template ng-label-tmp let-item="item">
                        {{ item.consecutivo }} - {{ item.descripcion_ocurrido | slice:0:40 }}
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item">
                        {{ item.consecutivo }} - {{ item.descripcion_ocurrido | slice:0:60 }}
                      </ng-template>
                    </ng-select>
                  </div>

                  <div class="col-md-3">
                    <label class="form-label text-dark">Metodología: <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" formControlName="metodologia"
                      placeholder="Ej: Matriz de Haddon, Árbol de causas...">
                  </div>

                  <div class="col-md-3">
                    <label class="form-label text-dark">Responsable de la investigación: <span
                        class="text-danger">*</span></label>

                    <ng-select [items]="colaboradores" bindLabel="nombreCompleto" bindValue="cedula"
                      [loading]="cargandoColaboradores" [searchable]="true" [clearable]="true"
                      placeholder="Seleccione un colaborador..." formControlName="responsable_investigacion">

                      <ng-template ng-option-tmp let-colaborador="item">
                        <div>{{ colaborador.nombreCompleto }} - {{ colaborador.cargo }}
                        </div>
                      </ng-template>

                    </ng-select>
                  </div>

                  <div class="col-md-3">
                    <label class="form-label text-dark">Fecha de inicio: <span class="text-danger">*</span></label>
                    <input type="date" class="form-control" formControlName="fecha_inicio">
                  </div>

                  <div class="col-md-6">
                    <label class="form-label text-dark">Entrevistas realizadas</label>
                    <textarea class="form-control" rows="3" formControlName="entrevistas_realizadas"></textarea>
                  </div>

                  <div class="col-md-6">
                    <label class="form-label text-dark">Evidencia recolectada</label>
                    <textarea class="form-control" rows="3" formControlName="evidencia_recolectada"></textarea>
                  </div>

                  <div class="col-md-6">
                    <label class="form-label text-dark">Reconstrucción de los hechos</label>
                    <textarea class="form-control" rows="3" formControlName="reconstruccion_hechos"></textarea>
                  </div>

                  <div class="col-md-6">
                    <label class="form-label text-dark">Conclusiones</label>
                    <textarea class="form-control" rows="3" formControlName="conclusiones"></textarea>
                  </div>

                </div>
              </div>

              <div class="d-flex justify-content-center gap-2 mt-4">
                <button type="submit" class="btn btn-primary px-4" [disabled]="guardando">
                  <span *ngIf="!guardando">
                    <i class="icofont icofont-save me-1"></i>{{ modoEdicion ? 'Actualizar' : 'Guardar' }}
                  </span>
                  <span *ngIf="guardando">
                    <span class="spinner-border spinner-border-sm me-1"></span>Guardando...
                  </span>
                </button>
                <button type="button" class="btn btn-secondary px-4" *ngIf="modoEdicion" (click)="cancelarEdicion()">
                  <i class="icofont icofont-close me-1"></i>Cancelar edición
                </button>
              </div>
            </form>
          </ng-template>
        </li>

        <!-- TAB 2: LISTADO -->
        <li [ngbNavItem]="2">
          <a ngbNavLink><strong><i class="icofont icofont-listine-dots me-1"></i> LISTADO INVESTIGACIONES</strong></a>
          <ng-template ngbNavContent>
            <div class="card card-absolute rounded mt-3 border-0 shadow-sm">
              <div class="card-body pt-3">

                <div *ngIf="cargandoListado" class="text-center py-4">
                  <div class="spinner-border text-primary" role="status"></div>
                  <p class="mt-2 mb-0">Cargando investigaciones...</p>
                </div>

                <div class="row mb-3 align-items-center" *ngIf="!cargandoListado">
                  <div class="col-md-3">
                    <select class="form-select" [(ngModel)]="filtroEstado" (change)="aplicarFiltro()">
                      <option [ngValue]="null">Todos</option>
                      <option [ngValue]="1">En curso</option>
                      <option [ngValue]="2">Cerradas</option>
                      <option [ngValue]="0">Inactivas</option>
                    </select>
                  </div>
                  <div class="col-md-4 ms-auto">
                    <div class="input-group">
                      <input type="text" class="form-control" placeholder="Buscar por consecutivo o responsable..."
                        [(ngModel)]="filtro" (input)="aplicarFiltro()">
                      <span class="input-group-text"><i class="fa fa-search"></i></span>
                    </div>
                  </div>
                </div>

                <div *ngIf="!cargandoListado" class="table-responsive mt-2">
                  <ng-container *ngIf="investigacionesFiltradas?.length > 0; else sinDatos">
                    <table id="tblInvestigacionSiniestro" class="table table-bordered table-hover align-middle">
                      <thead class="bg-primary text-white">
                        <tr>
                          <th class="text-center">SINIESTRO</th>
                          <th class="text-center">METODOLOGÍA</th>
                          <th class="text-center">RESPONSABLE</th>
                          <th class="text-center">FECHA INICIO</th>
                          <th class="text-center">FECHA CIERRE</th>
                          <th class="text-center">ESTADO</th>
                          <th class="text-center">ACCIONES</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          *ngFor="let inv of investigacionesFiltradas | paginate: { itemsPerPage: pageSize, currentPage: page }">
                          <td class="text-center">{{ inv.SiniestroData?.consecutivo || '-' }}</td>
                          <td class="text-center">{{ inv.metodologia }}</td>
                          <td class="text-center text-uppercase">{{ inv.ResponsableInvestigacionData?.nombreCompleto || '-' }}</td>
                          <td class="text-center">{{ inv.fecha_inicio | date:'dd/MM/yyyy' }}</td>
                          <td class="text-center">{{ inv.fecha_cierre ? (inv.fecha_cierre | date:'dd/MM/yyyy') : '-' }}
                          </td>
                          <td class="text-center">
                            <span class="badge rounded-pill" [ngClass]="{
                                'bg-warning text-dark': inv.estado === 1,
                                'bg-success': inv.estado === 2,
                                'bg-secondary': inv.estado === 0
                              }">
                              {{ inv.estado === 1 ? 'En curso' : inv.estado === 2 ? 'Cerrada' : 'Inactiva' }}
                            </span>
                          </td>
                          <td class="text-center">
                            <div class="d-flex justify-content-center gap-1">
                              <button class="btn btn-sm btn-outline-primary rounded-pill btn-rounded"
                                ngbTooltip="Ver Gestión"
                                (click)="Gestion(inv)">
                                <i class="icofont icofont-tasks-alt" style="font-size:.85rem;"></i>
                              </button>
                              <button class="btn btn-sm btn-outline-secondary rounded-pill btn-rounded"
                                ngbTooltip="Editar" *ngIf="inv.estado === 1" (click)="editar(inv)">
                                <i class="icofont icofont-pencil" style="font-size:.85rem;"></i>
                              </button>
                              <button class="btn btn-sm btn-outline-success rounded-pill btn-rounded"
                                ngbTooltip="Cerrar investigación" *ngIf="inv.estado === 1"
                                (click)="cerrarInvestigacion(inv)">
                                <i class="icofont icofont-check" style="font-size:.85rem;"></i>
                              </button>
                              <button class="btn btn-sm btn-outline-danger rounded-pill btn-rounded"
                                ngbTooltip="Inactivar" *ngIf="inv.estado !== 0" (click)="inactivar(inv)">
                                <i class="icofont icofont-close" style="font-size:.85rem;"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <div class="d-flex justify-content-between align-items-center mt-4">
                      <div class="d-flex align-items-center">
                        <label class="me-2">Mostrar:</label>
                        <select class="form-select w-auto" [(ngModel)]="pageSize" (change)="page = 1">
                          <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
                        </select>
                        <span class="ms-2">registros por página</span>
                      </div>
                      <div class="text-center flex-grow-1">
                        Total Registros: <a class="badge badge-primary"><b>{{ investigacionesFiltradas?.length || 0
                            }}</b></a>
                      </div>
                      <div class="text-end">
                        <pagination-controls (pageChange)="page = $event" [maxSize]="5" [directionLinks]="true"
                          [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente"></pagination-controls>
                      </div>
                    </div>
                  </ng-container>

                  <ng-template #sinDatos>
                    <div class="text-center py-4 text-primary">No hay investigaciones registradas.</div>
                  </ng-template>
                </div>
                    <div class="mt-4">
                      <div class="btn-showcase text-center">
                        <button class="btn btn-outline-success-2x" type="button" ngbTooltip="Exportar a Excel"
                          (click)="exportarExcel('tblInvestigacionSiniestro','listado_investigacion_siniestros')">
                          <i class="icofont icofont-file-excel"></i> EXCEL
                        </button>
                        <button class="btn btn-outline-danger-2x" type="button" ngbTooltip="Exportar a PDF"
                          (click)="exportToPDF('tblInvestigacionSiniestro','listado_investigacion_siniestros','Listado investigación de siniestros')">
                          <i class="icofont icofont-file-pdf"></i> PDF
                        </button>
                      </div>
                    </div>
              </div>
            </div>
          </ng-template>
        </li>
      </ul>

      <div [ngbNavOutlet]="investigacionTab" class="mt-2"></div>
    </div>
  </div>
</div>